import createLucideIcon from '../createLucideIcon';

const Menu = createLucideIcon('MenuIcon', [
  ['line', { x1: '4', y1: '12', x2: '20', y2: '12', key: '1q6rtp' }],
  ['line', { x1: '4', y1: '6', x2: '20', y2: '6', key: '1jr6gt' }],
  ['line', { x1: '4', y1: '18', x2: '20', y2: '18', key: '98tuvx' }],
]);

export default Menu;
